import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import { IconButton } from 'SelfServeBuilder';
import { PreviewIcon } from 'DesignSystem/Icons';
import { PrimaryButton } from 'DesignSystem/Buttons';
import RecipientsList from './RecipientsList';

const AddRecipientsBody = props => (
  <React.Fragment>
    <div className="content-container">
      <div className="panel-body-header">
        <h3 className="left">Add Recipients</h3>
        {props.isPreviewButtonEnabled && (
          <IconButton
            classnames="preview-button"
            text="View as Recipient"
            icon={<PreviewIcon />}
            containerClass="right full-height"
            onClick={props.openPreview}
            imageAlt="Preview"
            imageWidth={16}
          />
        )}
      </div>
      <div className="share-emails-container">
        <p>Each recipient will get their own individual copy of your document to fill out.</p>
        <RecipientsList
          emails={props.emails}
          handleBlur={props.handleBlur}
          handleEmailChange={props.handleEmailChange}
          hasEmailInputBlurred={props.hasEmailInputBlurred}
          removeEmailField={props.removeEmailField}
        />
        <IconButton
          text="Add a New Recipient"
          imageSrc="/images/self-serve-builder/side-panel/add-new-recipient-icon-2x.png"
          containerClass="new-email-button-container right"
          onClick={props.addNewEmailField}
          imageAlt="Add Recipient"
          imageWidth={16}
          buttonClass="add-recipient-btn"
        />
      </div>
      <div className="side-panel-divider" />
      <div className="message-container">
        <p>Message</p>
        <textarea value={props.currentMessage} onChange={props.handleMessageChange} />
        <div className="buttons-container">
          {!props.publishedAt &&
            <IconButton
              text="Cancel"
              containerClass="left full-height"
              onClick={props.clickCancel}
            />
          }
          <div
            className="right"
            data-class="empty-template-tooltip"
            data-delay-hide="50"
            data-tip={props.isTemplateEmpty ? 'tooltip' : null}
          >
            <PrimaryButton
              onClick={props.isEditingPopup ? props.setPopupCreationError : props.clickSend}
              disabled={props.sendDisabled || props.isTemplateEmpty}
            >
              Send
            </PrimaryButton>
          </div>

          {
            props.isTemplateEmpty &&
            <ReactTooltip
              className="empty-template-tooltip"
              place="bottom"
              type="light"
              effect="solid"
              getContent={[
                () => (
                  <div>
                    {props.emptyTemplateTooltipText}
                  </div>
                ),
              ]}
            />
          }
        </div>
      </div>
    </div>
  </React.Fragment>
);

AddRecipientsBody.defaultProps = {
  isEditingPopup: false,
  isPreviewButtonEnabled: true,
  isTemplateEmpty: false,
  openPreview: null,
  publishedAt: null,
};

AddRecipientsBody.propTypes = {
  addNewEmailField: PropTypes.func.isRequired,
  clickCancel: PropTypes.func.isRequired,
  clickSend: PropTypes.func.isRequired,
  currentMessage: PropTypes.string.isRequired,
  emails: PropTypes.arrayOf(
    PropTypes.string,
  ).isRequired,
  emptyTemplateTooltipText: PropTypes.string.isRequired,
  handleBlur: PropTypes.func.isRequired,
  handleEmailChange: PropTypes.func.isRequired,
  handleMessageChange: PropTypes.func.isRequired,
  hasEmailInputBlurred: PropTypes.arrayOf(
    PropTypes.bool,
  ).isRequired,
  isEditingPopup: PropTypes.bool,
  isPreviewButtonEnabled: PropTypes.bool,
  isTemplateEmpty: PropTypes.bool,
  openPreview: PropTypes.func,
  publishedAt: PropTypes.string,
  removeEmailField: PropTypes.func.isRequired,
  sendDisabled: PropTypes.bool.isRequired,
  setPopupCreationError: PropTypes.func.isRequired,
};


export default AddRecipientsBody;



// WEBPACK FOOTER //
// ./src-react/SelfServePostBuilderSidePanel/RecipientManager/AddRecipientsBody.jsx